import { snakeToCamel } from '../../../utils/object'

import Model from '../models'

import EvaluationQuestion from '@/services/evaluationQuestions/'

import EvaluationResponseAPI from './api'

export default class EvaluationResponse extends Model {
  static api = EvaluationResponseAPI.create(EvaluationResponse)
  static readOnlyFields = ['id', 'question']

  //NA Problem

  constructor({
    id = null,
    response = '',
    evaluation = null,
    questionRef = {},
    includeInReport = true,
    evaluationOrder = null,
  } = {}) {
    super()
    Object.assign(this, {
      id,
      response,
      evaluation,
      questionRef,
      includeInReport,
      evaluationOrder,
    })
  }

  static create(opts = {}) {
    if (opts.question_ref) {
      opts.question_ref = opts.question_ref.map(EvaluationQuestion.fromAPI)
    }
    return new EvaluationResponse(opts)
  }

  static fromAPI(json = {}) {
    const camelJson = snakeToCamel(json)
    if (camelJson.question_ref) {
      camelJson.question_ref = camelJson.question_ref.map(EvaluationQuestion.fromAPI)
    }
    return new EvaluationResponse(camelJson)
  }

  copy() {
    return new EvaluationResponse(this)
  }
}
